<template>
  <div>
    <v-btn color="techBlue" outlined class="mr-2" @click="dialog = true">
      AI Report
      <v-icon right>mdi-open-in-app</v-icon>
    </v-btn>

    <AiReportDialog v-model="dialog" />
  </div>
</template>

<script>
import AiReportDialog from "@/components/dialogs/AiReportDialog.vue";

export default {
  name: "AiReportBtnDropdown",
  components: {
    AiReportDialog,
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
